import { useLayoutEffect as n } from "react";
import { disableBodyScroll as s, enableBodyScroll as d } from "body-scroll-lock";
const u = (l, r) => {
  n(() => {
    var t;
    if (typeof window > "u") return;
    const e = r.current;
    if (e && l) {
      const c = ((t = document.scrollingElement) == null ? void 0 : t.scrollTop) ?? 0;
      try {
        s(e);
      } catch (o) {
        console.error("Failed to disable body scroll:", o);
      }
      return () => {
        try {
          d(e);
        } catch (o) {
          console.error("Failed to enable body scroll:", o);
        }
        if (document.scrollingElement) {
          const { scrollBehavior: o } = document.documentElement.style;
          document.documentElement.style.scrollBehavior = "initial", document.scrollingElement.scrollTop = c, document.documentElement.style.scrollBehavior = o;
        }
      };
    }
  }, [l, r]);
};
export {
  u
};
//# sourceMappingURL=useDisableBodyScroll-LjwRIuxh.mjs.map
